// utilities/errorHandler/info.ts - utilities/errorHandler.ts split (sub-module info)


import type {ErrorInfo} from './types.js';
import type {ErrorType} from './types.js';
import { getErrorType } from './classify.js';
import { getUserFriendlyMessage } from './friendly.js';
import { isRetryable } from './checks.js';


// ============== Error Info Builder ==============

/**
 * Creates an ErrorInfo object with all necessary metadata
 */
export function createErrorInfo(
  error: unknown,
  options: {
    type?: ErrorType;
    message?: string;
    isRetryable?: boolean;
    suggestion?: string;
    context?: Record<string, unknown>;
  } = {}
): ErrorInfo {
  const {
    type: explicitType,
    message: explicitMessage,
    isRetryable: explicitRetryable,
    suggestion,
    context,
  } = options;
  
  const detectedType = explicitType ?? getErrorType(error);
  const detectedMessage = explicitMessage ?? getUserFriendlyMessage(
    error,
    "Terjadi kesalahan yang tidak diketahui",
    context?.operation as string
  );
  const detectedIsRetryable = explicitRetryable ?? isRetryable(error);
  
  return {
    type: detectedType,
    message: detectedMessage,
    originalError: error,
    isRetryable: detectedIsRetryable,
    suggestion: suggestion ?? getDefaultSuggestion(detectedType),
    context: context,
    timestamp: new Date(),
  };
}



/**
 * Gets default recovery suggestions for error types
 */
function getDefaultSuggestion(type: ErrorType): string {
  const suggestions: Record<ErrorType, string> = {
    network: "Periksa koneksi internet dan coba lagi.",
    api: "Silakan hubungi dukungan teknis jika masalah berlanjut.",
    timeout: "Coba lagi setelah beberapa saat.",
    permission: "Pastikan Anda memiliki akses yang cukup atau login kembali.",
    validation: "Periksa input Anda dan coba lagi.",
    cache: "Muat ulang halaman untuk mendapatkan data terbaru.",
    realtime: "Memuat ulang koneksi real-time...",
    general: "Silakan coba lagi.",
  };
  
  return suggestions[type];
}
